export const EVENT_DISPLAYNAME_MAXLENGTH = 100;
export const HOSTNAME_MAXLENGTH = 50;